import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { FAQS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/faqs/")({
  component: () => <DeptContentList cfg={FAQS} />,
});
